import { BRAND_BLUE } from "../../theme/colors";

export const MEMBERSHIP_TOOLTIP_PROPS = {
  arrow: true,
  slotProps: {
    tooltip: {
      sx: {
        bgcolor: BRAND_BLUE,
        color: "#ffffff",
        fontSize: 12,
        fontWeight: 700,
      },
    },
    arrow: {
      sx: {
        color: BRAND_BLUE,
      },
    },
  },
};
